<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";

export default {
  locales: {
    pt: {
      months: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],

      'Withdrawal History': 'Histórico de Saques',
      'Value': 'Valor',
      'Fee': 'Taxa plataforma',
      'Taxes': 'Impostos',
      'Taxes help': 'Retenção INSS (11% sobre PF); zerado para PJ.',
      'Transfered': 'Transferido',
      'Transaction': 'Transação',
      'Awaiting processing': 'Aguardando processamento',
      'Awaiting invoice': 'Aguardando validação da NF',
      'Canceled': 'Recusado',
      'Completed': 'Completo',
      'View Transaction': 'Ver Transação',
      'Detail': 'Detalhe',

      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.',
      'No records found.': 'Nenhum registro encontrado.',
    },
    es: {
      months: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],

      'Withdrawal History': 'Historia de Retirada',
      'Value': 'Valor',
      'Fee': 'Tasa plataforma',
      'Taxes': 'Impuestos',
      'Taxes help': 'Retención INSS (11% PF); cero para PJ.',
      'Transfered': 'Transferido',
      'Transaction': 'Transacción',
      'Awaiting processing': 'En espera de procesamiento',
      'Awaiting invoice': 'Esperando validación de NF',
      'Canceled': 'Rechazado',
      'Completed': 'Completo',
      'View Transaction': 'Ver Transacción',
      'Detail': 'Detalle',

      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtelo de nuevo más tarde.',
      'No records found.': 'No se encontraron registros.',
    }
  },
  components: {
    Layout,
    VclList
  },
  data() {
    return {
      table: {
        body: null,
        loading: true,
        errored: false,
        empty: false,
      },
    };
  },
  methods: {
    getWithdrawals() {
      this.table.body = null

      this.table.loading = true
      this.table.errored = false
      this.table.empty = false

      api
        .get('wallet/withdrawal')
        .then(response => {
          if (response.data.status == 'success') {
            this.table.body = response.data.list || []
          } else {
            this.table.body = []
          }
        })
        .catch(error => {
          this.table.errored = error
        })
        .finally(() => {
          this.table.loading = false
          if (!this.table.body || this.table.body.length === 0) {
            this.table.empty = true
          }
        })
    },
    pixLabel(row) {
      if (!row.pix) return '';
      return (row.pix.type || '') + ' — ' + (row.pix.key || '');
    },
    taxesInss(row) {
      if (!row || row.person_type === 'legal') {
        return 0;
      }
      const n = parseFloat(row.inss);
      return Number.isFinite(n) ? n : 0;
    },
  },
  mounted() {
    this.getWithdrawals()
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/wallet/extract">Financeiro</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">{{ t('Withdrawal History') }}</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Withdrawal History') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="table.errored">{{ t('We apologize, we are unable to retrieve information at this time. Please try again later.') }}</div>
        <div v-else-if="table.empty">{{ t('No records found.') }}</div>
        <div v-else class="table-responsive">
          <vcl-list v-if="table.loading" class="col-lg-6"></vcl-list>
          <table v-else class="table table-centered table-nowrap">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>{{ t('Transaction') }}</th>
                <th>PIX</th>
                <th>{{ t('Value') }}</th>
                <th>{{ t('Fee') }}</th>
                <th>{{ t('Taxes') }}</th>
                <th>{{ t('Transfered') }}</th>
                <th>Status</th>
                <th>{{ t('Detail') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in table.body" :key="row.id">
                <td>{{ row.id }}</td>
                <td class="notranslate">{{ row.date }}</td>
                <td class="notranslate small">{{ pixLabel(row) }}</td>
                <td>{{ row.value | currency }}</td>
                <td>{{ row.fee != null ? (row.fee | currency) : '—' }}</td>
                <td>{{ taxesInss(row) | currency }}</td>
                <td>{{ row.transfered | currency }}</td>
                <td>
                  <span v-if="row.status === '0'" class="badge badge-soft-warning font-size-12">{{ t('Awaiting processing') }}</span>
                  <span v-else-if="row.status === '1'" class="badge badge-soft-success font-size-12">{{ t('Completed') }}</span>
                  <span v-else-if="row.status === '2'" class="badge badge-soft-danger font-size-12">{{ t('Canceled') }}</span>
                  <span v-else-if="row.status === '3'" class="badge badge-soft-info font-size-12">{{ t('Awaiting invoice') }}</span>
                </td>
                <td>
                  <router-link :to="'/wallet/withdrawal/' + row.id" class="btn btn-sm btn-link p-0">{{ t('Detail') }}</router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Layout>
</template>
